import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './ficha.css';
import 'materialize-css/dist/css/materialize.min.css';

// Função para buscar o personagem
async function fetchCharacter(id) {
  try {
    const response = await fetch(`https://olddragon.com.br/personagens/${id}.json`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Erro na requisição: ${response.status}`);
    }
    console.log(response);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Erro ao buscar personagem:', error);
    return null;
  }
}



function Ficha() {
  const [person, setPerson] = useState(null); // Estado para armazenar o personagem
  const [searchParams] = useSearchParams(); // Pegar parâmetros da query string
  const id = searchParams.get('id'); // Extrair o 'id' da URL
  const navigate = useNavigate();
  const [isMestre, setIsMestre] = useState(true);

  // Buscar o personagem quando o componente montar ou o 'id' mudar
  useEffect(() => {
    const getCharacter = async () => {
      if (id) {
        const data = await fetchCharacter(id);
        console.log(data);
        setPerson(data);
        setIsMestre(false);
      }
    };
    getCharacter();
  }, [isMestre]); // Dependência: re-executa se o 'id' mudar

  // Renderização condicional enquanto os dados carregam ou se houver erro
  if (!id) {
    return <div>Por favor, forneça um ID na URL (ex.: ?id=123)</div>;
  }

  if (!person) {
    return <div>Carregando personagem...</div>;
  }

  const voltarPagina = () => {
    navigate(-1); // Isso volta para a página anterior no histórico
  };
  const recarregar = () => {
    setIsMestre(true);
  };

  let itens = person.inventory_items
    .filter(item => item.equipped && item.concept === 'weapon')
    .map((item, index) => (
      <div class="row m-1">
        <div class="col s5" key={index}>
          {item.name}
        </div>
        <div class="col s2 center-align">
          {person.bac + (item.bonus_ba ?? 0)}
        </div>
        <div class="col s2 center-align">
          {person.bad + (item.bonus_ba ?? 0)}
        </div>
        <div class="col s3 center-align">
          {item.damage} {item.bonus_damage + person.mod_forca == null ? '' : `+${item.bonus_damage + person.mod_forca}`}
        </div>
      </div>
    ));

  return (
    <div className="personagens">
      <div class="row m-0">
        <div class="col s6">
          <a class="waves-effect btn-small" onClick={voltarPagina}>Voltar</a>
        </div>
        <div class="col s6 right-align">
          <a class="waves-effect btn-small " onClick={recarregar}>Recarregar</a>
        </div>
      </div>
      <div class="row">
        <div class="col s3 center-align">
          <img
            src={person.picture}
            alt={person.name}
            className="img-person"
          />

        </div>
        <div class="col s9">
          <h5 class="name">{person.name}</h5>
          <span>
            {person.character_race_name} ◆ {person.character_class_name} ◆ Nível {person.level}
          </span>
        </div>
      </div>
      <div class="row m-2">
        <div class="col s4 center-align square"><span class="title">P.V.</span>
          <div class="row">
            <div class="col s6">

              {person.health_points}<br /><small>Atual</small>
            </div>
            <div class="col s6">
              {person.max_hp}<br /><small>Máximo</small>
            </div>
          </div>
        </div>
        <div class="col s8 center-align">
          <span class="title"> MOVIMENTO</span>
          <div class="row">
            <div class="col s3">
              {person.current_movement}<br /><small>Atual</small>
            </div>
            <div class="col s3">
              {person.movement_run}<br /><small>Correr</small>
            </div>
            <div class="col s3">
              {person.movement_climb}<br /><small>Escalar</small>
            </div>
            <div class="col s3">
              {person.movement_swim}<br /><small>Nadar</small>
            </div>
          </div>
        </div>
      </div>
      <div class="row m-2">
        <div class="col s2 center-align square"><span class="title">FOR</span>{person.forca}<br /><small>{person.mod_forca}</small></div>
        <div class="col s2 center-align"><span class="title">DES</span>{person.destreza}<br /><small>{person.mod_destreza}</small></div>
        <div class="col s2 center-align"><span class="title">CON</span>{person.constituicao}<br /><small>{person.mod_constituicao}</small></div>
        <div class="col s2 center-align"><span class="title">INT</span>{person.inteligencia}<br /><small>{person.mod_inteligencia}</small></div>
        <div class="col s2 center-align"><span class="title">SAB</span>{person.sabedoria}<br /><small>{person.mod_sabedoria}</small></div>
        <div class="col s2 center-align"><span class="title">CAR</span>{person.carisma}<br /><small>{person.mod_carisma}</small></div>
      </div>
      <div class="row m-2">
        <div class="col s2 center-align"><span class="title">CA</span>{person.ac}</div>
        <div class="col s2 center-align"><span class="title">BAC</span>{person.bac}</div>
        <div class="col s2 center-align"><span class="title">BAD</span>{person.bad}</div>
        <div class="col s2 center-align"><span class="title">JPC</span>{person.jpc}</div>
        <div class="col s2 center-align"><span class="title">JPD</span>{person.jpd}</div>
        <div class="col s2 center-align"><span class="title">JPS</span>{person.jps}</div>
      </div>
      <div class="row m-2">
        <div class="col s2 center-align"><span class="title">PO</span>{person.money_gp}</div>
        <div class="col s2 center-align"><span class="title">PP</span>{person.money_sp}</div>
        <div class="col s2 center-align"><span class="title">PC</span>{person.money_cp}</div>
        <div class="col s6 center-align"><span class="title">Experiencia</span>{person.experience_points}</div>        
      </div>
      <div class="row m-2">
        <div class="col s5">
          <span class="title">EQUIPAMENTO</span>
        </div>
        <div class="col s2 center-align">
          <span class="title">BAC</span>
        </div>
        <div class="col s2 center-align">
          <span class="title">BAD</span>
        </div>
        <div class="col s3 center-align">
          <span class="title">DANO</span>
        </div>
      </div>
      {itens == '' ? <div class="center-align">Nenhum item equipado</div> : itens}
    </div>
  );
}

export default Ficha;